// styles/theme.js
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#00A898',
    },
    secondary: {
      main: '#F87291',
    },
    error: {
      main: '#c10a0a',
    },
    background: {
      default: '#ffffff',
      gray: '#f1f1f1',
      backGray: '#F3F3F3',
      lightGray: '#f8f8f8',
    },
    text: {
      primary: '#202020',
      secondary: '#747775',
      gray: '#6A6A6A',
    },
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    button: {
      textTransform: 'none',
    },
  },
  custom: {
    grayInputs: '#b6b6b6',
    grayBorder: '#d9d9d9',
    grayDark: '#1F1F1F',
    gray: '#747775',
    grayLight: '#f1f1f1',
    greenLight: '#FCFFFF',
    white: '#ffffff',
    red: '#df1212',
    secondaryFontFamily: "'Roboto', sans-serif",
    link: 'blue',
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
          boder: 'none',
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#00A898',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#00A898',
            },
          },
        },
      },
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: {
          '&.Mui-selected': {
            backgroundColor: '#00A898',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#00A898',
            },
          },
        },
      },
    },
    MuiPickersMonth: {
      styleOverrides: {
        monthButton: {
          '&.Mui-selected': {
            backgroundColor: '#00A898',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#00A898',
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          width: '100%',
          height: '45px',
          borderRadius: '30px',
          border: '1px solid #b6b6b6',
          backgroundColor: '#ffffff',
          '& input': {
            fontFamily: "'Montserrat', sans-serif",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          border: 'none', 
        },
        root: {
          minHeight: '45px', 
          height: '45px',   
          borderRadius: '30px', 
        },
      },
    },
    
  },
  
  
});
